export default {
  business: {
    eyebrow: '事業内容',
    hero: {
      title: '日本の化学品を世界とつなぐ',
      description:
        '欧米・アジアを中心とする世界中の顧客とのネットワークをベースに、迅速なソリューション提供能力を生かして、化学品・金属を中心とする商品の輸出入、三国間貿易、貿易に伴うサービスの提供などのビジネスを展開しております。',
    },
    supply: {
      title: '主要取扱い商品',
      description: ' ',
      moreInfo: '500種類以上の化学品を取り扱っています。',
      cta: '取扱化学品リストを見る',
      products: [
        // row 1
        'フッ素ケミカル', 'スパッタリングターゲット原料', 'めっき薬原料',
        // row 2
        'シリコーン', 'ナノ原料', '貴金属めっき薬原料',
        // row 3
        '樹脂原料', 'シランカップリング剤', '医薬中間体', '防錆剤原料',
        // row 4
        '各種モノマー', '無機顔料', '農薬中間体', '水処理関係薬品',
        // row 5
        '多価アルコール', '有機顔料', '食品添加物', '光学ガラス原料',
        // row 6
        '各種アルコール', '染料中間体', '化粧品原料', '超硬工具原料',
        // row 7
        '有機酸', 'カーボン原料', '動物飼料添加物', '特殊合金原料',
        // row 8
        '石油化学製品', '電池材料', 'キレート剤', 'チタン原料',
        // row 9
        '各種溶剤', 'フェライト原料', '製紙原料', '合成ゴム添加剤',
        // row 10
        'エラストマー', 'コンデンサ原料', '殺菌消毒剤原料', '研磨剤原料',
        // row 11
        '有機ゴム薬品', '太陽電池製造用薬品', 'はんだ原料', '耐火物原料',
        // row 12
        '塗料添加剤', 'PDP製造用薬品', 'セラミックス原料', '離型剤',
        // row 13
        '接着剤原料', '基板製造用薬品', 'ソーダ工業薬品', '清缶剤',
        // row 14
        'ポリウレタンフォーム原料', '二次電池材料', 'アンモニア系薬品', '肥料原料',
        // row 15
        '難燃剤', '蛍光体原料', '各種無機薬品', '各種酵素',
        // row 16
        '重合禁止剤', '半導体製造用薬品', 'レアメタル及び塩類', '香料原料',
        // row 17
        '界面活性剤', '封止剤原料', '触媒原料', '各種試薬',
        // row 18
        'イオン交換樹脂原料', '蒸着原料', 'ガラス原料', '（取扱化学品・金属等500種以上）',
        // row 19 (col 4 empty)
        '不凍液原料', 'LED原料', '表面処理薬原料',
      ],
    },
    manufacturers: {
      title: '主要仕入れ先',
      subtitle: '（50音順）',
      description: ' ',
      cta: '取扱化学品リストを見る',
      list: [
        '株式会社ADEKA',
        'AGCセイミケミカル株式会社',
        '天野エンザイム株式会社',
        '生駒薬化学工業株式会社',
        '石原産業株式会社',
        '伊勢化学工業株式会社',
        '伊藤製油株式会社',
        '乾庄貴金属化工株式会社',
        '株式会社井上香料製造所',
        'イハラニッケイ化学工業株式会社',
        '磐田化学工業株式会社',
        '上野製薬株式会社',
        'UBE株式会社',
        '宇部マテリアルズ株式会社',
        '圓商産業株式会社',
        '大内新興化学工業株式会社',
        '株式会社大阪ソーダ',
        '株式会社大阪チタニウムテクノロジーズ',
        'オリヱント化学工業株式会社',
        '川口化学工業株式会社',
        '川崎化成工業株式会社',
        '関西触媒化学株式会社',
        '関東化学株式会社',
        '稀産金属株式会社',
        'キシダ化学株式会社',
        'キンセイマテック株式会社',
        '株式会社クレハ',
        '五井化成株式会社',
        '広栄化学工業株式会社',
        '株式会社高純度化学研究所',
        '神島化学工業株式会社',
        '株式会社高南無機',
        '小島化学薬品株式会社',
        '三洋化成工業株式会社',
        '四国化成工業株式会社',
        '城北化学工業株式会社',
        '昭和エーテル株式会社',
        '昭和化学株式会社',
        '昭和化学工業株式会社',
        '昭和化工株式会社',
        '信越化学工業株式会社',
        '新興化学工業株式会社',
        '日鉄ケミカル＆マテリアル株式会社',
        '新日本電工株式会社',
        '新日本理化株式会社',
        '住友化学株式会社',
        '住友金属鉱山株式会社',
        '第一工業製薬株式会社',
        '株式会社ダイセル',
        'ダイセルファインケム株式会社',
        '大日精化工業株式会社',
        '大八化学工業株式会社',
        '太平化学産業株式会社',
        '太洋化学工業株式会社',
        '大和化成株式会社',
        '多木化学株式会社',
        'タテホ化学工業株式会社',
        '多摩化学工業株式会社',
        '田辺ファーマ株式会社',
        '淡南化学工業株式会社',
        '千葉ファインケミカル株式会社',
        'ディー・エス・エス株式会社',
        'テイカ株式会社',
        '寺田薬泉工業株式会社',
        '東亜合成株式会社',
        '東ソー株式会社',
        'トーヨーケム株式会社',
        '東洋合成工業株式会社',
        '東洋紡株式会社',
        '東レ・ファインケミカル株式会社',
        '株式会社トクヤマ',
        '富田製薬株式会社',
        '株式会社長井製薬所',
        'ニッキ株式会社',
        '日興リカ株式会社',
        '日産化学株式会社',
        '日東粉化商事株式会社',
        '日本イットリウム株式会社',
        '日本化学工業株式会社',
        '日本化学産業株式会社',
        '日本化成株式会社',
        '日本軽金属株式会社',
        '株式会社日本触媒',
        '日本テルペン化学株式会社',
        '日本乳化剤株式会社',
        '日本無機化学工業株式会社',
        '日油株式会社',
        '林 純薬工業株式会社',
        'ハリマ化成株式会社',
        '福田金属箔粉工業株式会社',
        '富士化学工業株式会社',
        '扶桑化学工業株式会社',
        '北興化学工業株式会社',
        '細井化学工業株式会社',
        '本荘ケミカル株式会社',
        '松垣薬品工業株式会社',
        '丸善石油化学株式会社',
        '三井化学株式会社',
        '三井化学ファイン株式会社',
        '三井金属鉱業株式会社',
        '三菱ガス化学株式会社',
        '三菱マテリアル株式会社',
        '三菱ケミカル株式会社',
        '株式会社三星化学研究所',
        'ミナルコ株式会社',
        '株式会社武蔵野化学研究所',
        '森田化学工業株式会社',
        'ヤクルト薬品工業株式会社',
        'ヤスハラケミカル株式会社',
        '大和金属粉工業株式会社',
        '有機合成薬品工業株式会社',
        '淀化学株式会社',
        '米山化学工業株式会社',
        'ラサ工業株式会社',
        '燐化学工業株式会社',
        'JNC株式会社',
        'JFEミネラル株式会社',
        'NIケミテック株式会社',
      ],
    },
    distribution: {
      title: '主要販売先',
      description:
        '日常のきめ細やかなサービス提供を通じて築いた強い信頼関係の下、世界各地のメーカー様及びディーラー様に商品を納入しております。',
    },
    regions: [
      {
        title: 'アジア',
        countries:
          'バングラデシュ、中国、香港、インド、インドネシア、イラン、韓国、クウェート、マレーシア、ネパール、パキスタン、フィリピン、サウジアラビア、シンガポール、スリランカ、台湾、タイ、トルコ、UAE、ウズベキスタン、ベトナム',
      },
      {
        title: 'ヨーロッパ',
        countries: 'オーストリア、ベルギー、フランス、ドイツ、アイルランド、イタリア、オランダ、スペイン、スウェーデン、スイス、ウクライナ、英国',
      },
      {
        title: '北米・中南米',
        countries: 'アルゼンチン、ブラジル、カナダ、メキシコ、ペルー、米国',
      },
      {
        title: 'その他',
        countries: 'オーストラリア、エジプト、モーリシャス、ニュージーランド、南アフリカ',
      },
    ],
  },
};
